import React, { useEffect, useState } from 'react'

import PropTypes from 'prop-types'
import { isEmpty } from 'lodash'
import { Box, Typography } from '@material-ui/core'

import { Card } from 'components'
import { PlanActionForm, PlanActionsHeaderButton } from './components'

import useThirdPartyManagementStepper from 'hooks/useThirdPartyManagementStepper'
import useFetch from 'hooks/useFetch'

import constants from 'constants/index'
import helpers from 'helpers'
import * as service from 'service'

const PlanActionsSection = ({ setHasDraftPlanAction }) => {
  const { companySupplier, isPreAvaliation } = useThirdPartyManagementStepper()

  const [evidencePlanActions, setEvidencePlanActions] = useState(
    companySupplier?.evidencePlanActions ?? [],
  )

  const { response: usersResponse, isLoading: isUsersLoading } = useFetch(
    service.dponet.users.get,
    {
      perPage: 10000,
      minimal: true,
      active: true,
      userCompanyStatus: constants.userCompanies.ACTIVE,
    },
  )

  const users = usersResponse?.data?.users || []

  const hasDraftPlanAction = evidencePlanActions.some((item) => !item?.id)

  const { STEPS } = constants.tours.thirdPartyManagements

  useEffect(() => {
    setHasDraftPlanAction(hasDraftPlanAction)
  }, [hasDraftPlanAction, setHasDraftPlanAction])

  return (
    <Card
      title="Planos de Ação"
      actionButton={
        <PlanActionsHeaderButton
          evidencePlanActions={evidencePlanActions}
          setEvidencePlanActions={setEvidencePlanActions}
        />
      }
      id={helpers.thirdPartyManegementPartners.getRisksTourStepId({
        STEPS,
        isPreAvaliation,
        fromCreate: false,
        step: 4,
      })}
    >
      <Box display="flex" flexDirection="column" gridGap={16}>
        {isEmpty(evidencePlanActions) && (
          <Typography variant="body2" color="textSecondary">
            Nenhum plano de ação adicionado.
          </Typography>
        )}

        {evidencePlanActions.map((evidencePlanAction) => (
          <PlanActionForm
            key={
              evidencePlanAction?.id ?? `draft-${evidencePlanAction?.draftKey}`
            }
            evidencePlanAction={evidencePlanAction}
            users={users}
            isUsersLoading={isUsersLoading}
            setEvidencePlanActions={setEvidencePlanActions}
          />
        ))}
      </Box>
    </Card>
  )
}

PlanActionsSection.propTypes = {
  setHasDraftPlanAction: PropTypes.func.isRequired,
}

export default PlanActionsSection
